import React from "react";

// components
import { Card, CardBody, CardFooter, Button, Row, Col, } from "reactstrap";

// views
import RelatorioFichaRequerimentoGeradorRSS from "./Fichas/RelatorioFichaRequerimentoGeradorRSS";
import RelatorioManutecaoGeradorRSS from './Fichas/RelatorioManutecaoGeradorRSS';
import RelatorioManutecaoTransportadores from "./Fichas/RelatorioManutecaoTransportadores";
import RelatorioManutecaoDestinos from "./Fichas/RelatorioManutecaoDestinos";

// services
import { showMessage } from "../../services/message.js";
import ValidaAcessoFuncionalidadeAcao from "../../services/acesso.js";
import RelatorioFichaRequerimentoGeradorRGG from "./Fichas/RelatorioFichaRequerimentoGeradorRGG";
import RelatorioCadastroGeradores from "./Fichas/RelatorioCadastroGeradores";

export default function ListaRelatorios({ history }) {

  const list_table = [
    {
      codigo: "Relatorios.RequerimentoGeradorRGG",
      title: "Requerimento de Geradores de RGG",
      description: "Relatório detalhado de requerimentos de geradores de RGG.",
      component: (<RelatorioFichaRequerimentoGeradorRGG handleReturn={() => set_showFicha(false)} />)
    },
    {
      codigo: "Relatorios.RequerimentoGeradorRSS",
      title: "Requerimento de Geradores de RSS",
      description: "Relatório detalhado de requerimentos de geradores de RSS.",
      component: (<RelatorioFichaRequerimentoGeradorRSS handleReturn={() => set_showFicha(false)} />)
    },
    {
      codigo: "Relatorios.ManutencaoGeradoresRSS",
      title: "Manutenção de Geradores",
      description: "Relatório Detalhado de Manutenção de Geradores.",
      component: (<RelatorioManutecaoGeradorRSS handleReturn={() => set_showFicha(false)} />)
    },
    {
      codigo: "Relatorios.ManutencaoTransportadores",
      title: "Manutenção de Transportadores",
      description: "Relatório Detalhado de Manutenção de Transportadores.",
      component: (<RelatorioManutecaoTransportadores handleReturn={() => set_showFicha(false)} />)
    },
    {
      codigo: "Relatorios.ManutencaoDestinos",
      title: "Manutenção de Destinos",
      description: "Relatório Detalhado de Manutenção de Destinos.",
      component: (<RelatorioManutecaoDestinos handleReturn={() => set_showFicha(false)} />)
    },
    {
      codigo: "Relatorios.RelatorioCadastroGeradores",
      title: "Relatório Cadastro de Geradores",
      description: "Relatório Detalhado de Cadastro de Geradores",
      component: (<RelatorioCadastroGeradores handleReturn={() => set_showFicha(false)} />)
    },
  ];

  const [showFicha, set_showFicha] = React.useState(false);
  const [ficha, set_ficha] = React.useState(null);

  const handleFicha = (item) => {
    ValidaAcessoFuncionalidadeAcao(item.codigo, function (result) {
      if (result) {
        set_showFicha(true);
        set_ficha(item.component);
      }
      else {
        showMessage("Aviso", "Usuário não possui acesso a este relatório", 'error', null);
      }
    });
  }

  return (
    <>
      {!showFicha &&
        <div className="content">
          <Row className="d-flex align-items-stretch">
            {list_table.map((m, key) => (
              <Col key={key} lg="4" md="6" sm="12" className="mt-3">
                <Card className="h-100">
                  <CardBody className="rel-card-body">
                    <h5>{m.title}</h5>
                    {m.description}
                  </CardBody>
                  <CardFooter className="text-right">
                    <Button color="warning" className="btn-mobile" onClick={() => handleFicha(m)}>Visualizar Relatório</Button>
                  </CardFooter>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      }
      {showFicha &&
        ficha
      }
    </>
  );
}

